import { makeStyles, Text } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";
import { SmokeSummary } from "../model/SmokeSummary";
import { slThemeLight } from "../slTheme";
import { IAppContext } from "../model/IAppContext";
import { TheAppContext } from "../model/AppContext";
import { Therm } from "../model/Therm";
import { ThermReadingItem } from './ThermReadingItem';
import { RexDateTime } from '../Dates/RexDateTime';

export interface SmokeSummaryDetailsProps
{
    styles: Record<string, string>;
    smokeSummary: SmokeSummary;
}

export interface SmokeSummaryDetailsState
{
    description: string;
    lastUpdate: string;
    therms: Therm[]
}

const useStyles = makeStyles(
    {
        summaryHeadingData:
        {
            fontWeight: slThemeLight.fontWeightBold
        },
        thermContainer:
        {
            display: 'flex',
            flexDirection: 'row',
            columnGap: '10pt'
        }
    });

export class SmokeSummaryDetailsWithoutStyles extends React.Component<SmokeSummaryDetailsProps, SmokeSummaryDetailsState>
{
    context!: IAppContext;
    static contextType = TheAppContext;

    constructor(props: SmokeSummaryDetailsProps)
    {
        super(props);

        this.state =
        {
            description: `Updating for ${this.props.smokeSummary.SmokeID}...`,
            lastUpdate: "never",
            therms: []
        };
    }

    getLastUpdateFromSummary(smoke: SmokeSummary): string
    {
        let latestDate = new RexDateTime(0);

        for (const therms of smoke.AllThermReadings.values())
        {
            for (const reading of therms.Readings)
            {
                if ((reading.Timestamp as RexDateTime).utcValue > latestDate.utcValue)
                    latestDate = reading.Timestamp as RexDateTime;
            }
        }

        if ((latestDate as RexDateTime).utcValue == 0)
            return "never";

        return latestDate.toLongLocalDateTimeString();
    }

    async updateSmokeInfo(smoke: SmokeSummary)
    {
        const [smokeFull, therms] =
            await Promise.all(
                [
                    this.context.WebApi.getSmokeFull(smoke.SmokeID),
                    this.context.WebApi.getTherms(smoke.SmokeID)
                ]);

        if (smokeFull.TheValue?.Description == null)
            return;

        const description = smokeFull.TheValue.Description;
        const lastUpdate = this.getLastUpdateFromSummary(smoke);

        this.setState(
            {
                description: description,
                lastUpdate: lastUpdate,
                therms: therms?.TheValue ?? []
            });
    }

    async componentDidMount()
    {
        await this.updateSmokeInfo(this.props.smokeSummary);
    }

    async componentDidUpdate(prevProps: SmokeSummaryDetailsProps)
    {
        if (prevProps.smokeSummary !== this.props.smokeSummary)
            await this.updateSmokeInfo(this.props.smokeSummary);
    }

    render()
    {
        const thermCount = this.state.therms.length;
        const therms = this.state.therms.map((therm, index) => (<ThermReadingItem targetWidth={100.0 / thermCount} key={index} description={therm.Description} readings={this.props.smokeSummary.thermReadings(therm.ThermID)}/>));

        return (
            <div className={this.props.styles.summaryHeading}>
                <div >
                    What's Smokin?
                    <Text className={this.props.styles.summaryHeadingData}> {this.state.description} </Text>
                </div>
                <div>
                    Last Update:
                    <Text className={this.props.styles.summaryHeadingData}> {this.state.lastUpdate} </Text>
                </div>
                <div className={this.props.styles.thermContainer}>
                    {therms}
                </div>
            </div>
        );
    }
}

export const SmokeSummaryDetails = withStyles(useStyles, SmokeSummaryDetailsWithoutStyles);